// Light, dark or follow the system. The choice is kept in this browser only.
export type ThemePref = "system" | "light" | "dark";

const KEY = "gbe.theme";

export function getTheme(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

/** Applies a theme to the page; "system" lets the operating system decide. */
export function applyTheme(pref: ThemePref = getTheme()) {
  const root = document.documentElement;
  if (pref === "system") delete root.dataset.theme;
  else root.dataset.theme = pref;
}

export function setTheme(pref: ThemePref) {
  try {
    if (pref === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, pref);
  } catch {
    /* storage unavailable: the choice lasts until the tab closes */
  }
  applyTheme(pref);
}
